module.exports = __webpack_public_path__ + "img/uhd.b5490e6.svg";